import { z } from 'zod';
/** Calendar scheduling v1: provider owns recurrence after creation. */
export const calendarSlotSchema = z
    .object({
    kind: z.enum(['one_off', 'weekly']),
    startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    localTime: z.string().regex(/^\d{2}:\d{2}$/),
    weekday: z.number().int().min(0).max(6).optional(),
    durationMinutes: z.number().int().min(1).max(1440),
    endDate: z
        .string()
        .regex(/^\d{4}-\d{2}-\d{2}$/)
        .optional(),
})
    .strict()
    .superRefine((slot, ctx) => {
    if (slot.kind === 'weekly' && slot.weekday === undefined)
        ctx.addIssue({ code: 'custom', message: 'Weekly slots require a weekday' });
    if (slot.endDate && (slot.kind !== 'weekly' || slot.endDate < slot.startDate))
        ctx.addIssue({ code: 'custom', message: 'Invalid series end date' });
});
export const calendarSetupRequestSchema = z
    .object({
    title: z.string().trim().min(1).max(200),
    timezone: z.string().min(1).max(100),
    sendInvitation: z.boolean().optional(),
    slots: z.array(calendarSlotSchema).min(1).max(20),
})
    .strict();
//# sourceMappingURL=calendar.js.map